import {ResultSchema} from 'results/assay-schemas/AssaySchemaConstants';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import ModalButtonKey from 'test/lib/cypress/shared/ModalButtonKey';
import {ButtonStyle} from 'ui-library/buttons/Button';

export interface ConfirmationButtonState {
  text: string;
  disabled: boolean;
  onClick: () => void;
  style?: ButtonStyle;
  dataTestAttrs?: DataTestAttrs;
}

const DEFAULT_BACK_BUTTON: Pick<ConfirmationButtonState, 'disabled' | 'style' | 'text'> = {
  disabled: false,
  style: ButtonStyle.TERTIARY_GRAY,
  text: 'Cancel',
};

const DEFAULT_NEXT_BUTTON: Pick<ConfirmationButtonState, 'disabled' | 'style' | 'text' | 'dataTestAttrs'> = {
  disabled: false,
  style: ButtonStyle.SECONDARY,
  text: 'Next',
  dataTestAttrs: {
    component: 'getDataMappingConfirmationButtons',
    key: ModalButtonKey.NEXT,
  },
};

export interface GetDataMappingConfirmationButtonsProps {
  onClose: () => void;
  onNext: () => void;
  resultSchema: ResultSchema | null;
}

export default function getDataMappingConfirmationButtons({
  onClose,
  onNext,
  resultSchema,
}: GetDataMappingConfirmationButtonsProps): Array<ConfirmationButtonState> {
  return [
    {...DEFAULT_BACK_BUTTON, onClick: onClose},
    {...DEFAULT_NEXT_BUTTON, disabled: resultSchema == null, onClick: onNext},
  ];
}
